import React from "react";
import { createIcon } from "@chakra-ui/react";
export const KebabIcon = createIcon({
  displayName: "KebabIcon",
  viewBox: "0 0 16 16",
  path: /* @__PURE__ */ React.createElement("path", { d: "M13,8a1.43,1.43,0,1,1-1.43-1.43A1.43,1.43,0,0,1,13,8ZM8,6.57A1.43,1.43,0,1,0,9.43,8,1.43,1.43,0,0,0,8,6.57Zm-3.57,0A1.43,1.43,0,1,0,5.86,8,1.43,1.43,0,0,0,4.43,6.57z" })
});
